<template>
  <div :class="{ 'no-select': hasAnyAnonymization }">
    <span
      v-if="history"
      class="title q-mb-sm"
    >Andamento da chamada</span>
    <div class="row q-mt-sm">
      <div class="column col-auto align">
        <div
          class="column q-mb-sm"
          v-for="action in history"
          :key="action.id"
        >
          <div class="content text-blue-grey-10 q-mr-lg">
            {{ handleEventName(action.event,action.info) }}
          </div>
          <div
            :key="action.createdAt"
            class="content text-grey-7 q-mr-lg"
          >
            {{ timeFormatted(action.createdAt) }}
          </div>
        </div>
      </div>

      <div class="column col-auto">
        <q-timeline
          color="blue"
          layout="dense"
        >
          <q-timeline-entry
            color="blue"
            v-for="action in history"
            :key="action.id"
            :class="handleTimelineTitleClass(action)"
            :subtitle="handleTimelineTitle(action)"
          />
        </q-timeline>
      </div>

      <div class="col q-pl-lg align">
        <div
          class="q-mb-sm description"
          v-for="action in history"
          :key="action.id"
        >
          <div
            class="text-left text-blue-grey-10 content q-mr-lg"
            v-html="handleEventDescription(action)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import formatElapsedSeconds from '@/libs/formatElapsedSeconds'
import { anonymizePhone } from '@/components/utils/phones'

const QUEUECALLER_JOIN = 'QUEUECALLER_JOIN'
const QUEUEMEMBER_CALLCONNECT = 'QUEUEMEMBER_CALLCONNECT'
const QUEUECALLER_ABANDON = 'QUEUECALLER_ABANDON'
const QUEUEMEMBER_CALLEND = 'QUEUEMEMBER_CALLEND'
const QUEUEMEMBER_CALLSTART = 'QUEUEMEMBER_CALLSTART'
const QUEUEMEMBER_CALLATTEMPT = 'QUEUEMEMBER_CALLATTEMPT'
const QUEUEMEMBER_CALLREJECT = 'QUEUEMEMBER_CALLREJECT'
const DIALER_CALLSTART = 'DIALER_CALLSTART'
const DIALER_CALLCONNECT = 'DIALER_CALLCONNECT'
const DIALER_CALLEND = 'DIALER_CALLEND'
const IVR_TAG = 'IVR_TAG'
const IVR_START = 'IVR_START'
const IVR_PLAYBACK = 'IVR_PLAYBACK'
const IVR_SAYDIGITS = 'IVR_SAYDIGITS'
const IVR_SAYNUMBER = 'IVR_SAYNUMBER'
const IVR_RUNCODE = 'IVR_RUNCODE'
const IVR_WEBSERVICE = 'IVR_WEBSERVICE'
const IVR_MENUSELECT = 'IVR_MENUSELECT'
const IVR_TEXTTOSPEECH = 'IVR_TEXTTOSPEECH'
const IVR_SPEECHTOTEXT = 'IVR_SPEECHTOTEXT'
const IVR_READ = 'IVR_READ'
const IVR_READDIGIT = 'IVR_READDIGIT'
const IVR_TRANSFERLOCAL = 'IVR_TRANSFERLOCAL'
const IVR_TRANSFERTOAGENT = 'IVR_TRANSFERTOAGENT'
const IVR_TRANSFEREXTERNAL = 'IVR_TRANSFEREXTERNAL'
const IVR_TRANSFERQUEUE = 'IVR_TRANSFERQUEUE'
const IVR_TRANSFERTOURA = 'IVR_TRANSFERTOURA'
const IVR_HANGUP = 'IVR_HANGUP'

export default {
  props: {
    position: {
      type: Number
    },

    status: {
      type: String
    },

    reason: {
      type: String
    },

    direction: {
      type: String
    },

    agentName: {
      type: String
    },

    history: {
      type: Array
    },
    tags: {}
  },

  methods: {
    timeFormatted (createdAt) {
      return new Date(createdAt * 1000).toLocaleTimeString('pt-br')
    },

    displayPhone (phone, queue) {
      if (!phone) return phone
      if (this.isAnonymizationEnabled(queue)) return anonymizePhone(phone)
      return phone
    },

    displayPhoneWithTooltip (phone, queue) {
      if (!phone) return phone
      const displayedPhone = this.displayPhone(phone, queue)
      const isAnonymized = this.isAnonymizationEnabled(queue)
      const style = isAnonymized ? 'user-select: none; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none;' : ''
      return `<span style="${style}" title="Número anonimizado por política de segurança">${displayedPhone}</span>`
    },

    handleEventName (event, action) {
      const { reason } = action
      switch (event) {
        case QUEUECALLER_ABANDON:
          return 'Abandonada'

        case QUEUECALLER_JOIN:
          return 'Fila de espera'

        case QUEUEMEMBER_CALLATTEMPT:
          return 'Oferecida'

        case DIALER_CALLSTART:
        case QUEUEMEMBER_CALLSTART:
          return 'Discada'

        case QUEUEMEMBER_CALLREJECT:
          return 'Recusada'

        case DIALER_CALLCONNECT:
        case QUEUEMEMBER_CALLCONNECT:
          return 'Atendida'

        case DIALER_CALLEND:
        case QUEUEMEMBER_CALLEND:
          if (reason === 'transfer') return 'Transferida'
          if (this.status === 'COMPLETED') return 'Completada'
          if (this.status === 'ABANDONED') return 'Abandonada'
          if (this.status === 'DISCARDED') return 'Descartada'
          return ''

        case IVR_TAG:
          return 'Classificada'

        case IVR_START:
          return 'Entrou na URA'

        case IVR_PLAYBACK:
          return 'Reproduziu áudio'

        case IVR_SAYDIGITS:
        case IVR_SAYNUMBER:
          return 'Fonou um número'

        case IVR_RUNCODE:
          return 'Executou script'

        case IVR_WEBSERVICE:
          return 'Request http'

        case IVR_MENUSELECT:
          return 'Seleção menu'

        case IVR_TEXTTOSPEECH:
          return 'Texto para Fala'

        case IVR_SPEECHTOTEXT:
          return 'Fala para texto'

        case IVR_READ:
          return 'Solicitou dado'

        case IVR_READDIGIT:
          return 'Dado Digitado'

        case IVR_TRANSFERLOCAL:
        case IVR_TRANSFERTOAGENT:
        case IVR_TRANSFEREXTERNAL:
        case IVR_TRANSFERQUEUE:
        case IVR_TRANSFERTOURA:
        case IVR_HANGUP:
          return 'Saiu da URA'

        default:
          return event
      }
    },

    handleEventDescription (action) {
      const { event, info, agentName, createdAt, uraName } = action
      const totalSecs = (info.ringSecs ?? 0) + (info.talkSecs ?? 0)
      const queue = info?.queue
      switch (event) {
        case QUEUECALLER_ABANDON:
          return `Entrou na fila na posição <b>${info.initialPosition}</b>, saiu da fila na posição <b>${info.position}</b> esperando ${formatElapsedSeconds(info.waitSecs)} até abandonar`

        case QUEUECALLER_JOIN:
          return `Chamada <b>${queue ? this.displayPhoneWithTooltip(info.callerNumber, queue) : info.callerNumber}</b> entrou na fila de espera<br>às ${this.timeFormatted(createdAt)}`

        case QUEUEMEMBER_CALLSTART:
          return `${agentName} discou para <b>${queue ? this.displayPhoneWithTooltip(info.dialedNumber, queue) : info.dialedNumber}</b>`

        case DIALER_CALLSTART:
          return `Discagem automática para <b>${queue ? this.displayPhoneWithTooltip(info.dialedNumber, queue) : info.dialedNumber}</b>`

        case DIALER_CALLCONNECT:
          return `Atendimento começou após ${formatElapsedSeconds(info.ringSecs)} de espera`

        case QUEUEMEMBER_CALLCONNECT:
          return `Entrou em atendimento com ${agentName}<br>após ${formatElapsedSeconds(info.ringSecs)} de espera`

        case QUEUEMEMBER_CALLATTEMPT:
          return `Oferecimento para o agente ${agentName}<br>às ${this.timeFormatted(createdAt)}`

        case DIALER_CALLEND:
          return `Chamada durou ${formatElapsedSeconds(totalSecs)}. Posição inicial <b>${this.position}</b>`

        case QUEUEMEMBER_CALLEND:
          return `Chamada durou ${formatElapsedSeconds(totalSecs)}${this.callEndStatus(action)}${this.callEndReason(action)}${this.callEndPosition(action)}`

        case QUEUEMEMBER_CALLREJECT:
          return `Agente ${agentName} recusou oferecimento<br>às ${this.timeFormatted(createdAt)}`

        case IVR_TAG:
          return `<b>${this.tags[info.infoIvrNode].tagName}</b> - Ura: ${this.tags[info.infoIvrNode].uraName}`

        case IVR_START:
          return `Chamada entrou na Ura <b>${uraName || ''}</b> através do número <b>${info.dnid}</b>`

        case IVR_PLAYBACK:
        case IVR_READ:
          return `Ura reproduziu o áudio: <b>${info.infoIvrNode}</b>`

        case IVR_SAYDIGITS:
        case IVR_SAYNUMBER:
          return `Ura informou Número: <b>${this.formatShowInfo(info)}</b>`

        case IVR_RUNCODE:
          return `Ura executou o script: <b>${info.infoIvrNode}</b>`

        case IVR_WEBSERVICE:
          return `Ura fez uma chamada para o webservice: <b>${info.infoIvrNode}</b>`

        case IVR_MENUSELECT:
          return this.formatMenuSelect(info.infoIvrNode)

        case IVR_TEXTTOSPEECH:
          return `Ura fonou o texto:<br><b>${this.formatShowInfo(info)}</b>`

        case IVR_SPEECHTOTEXT:
          return `Cliente falou:<br><b>${this.formatShowInfo(info)}</b>`

        case IVR_READDIGIT:
          return `Cliente informou dado:<br><b>${this.formatShowInfo(info)}</b>`

        case IVR_TRANSFERLOCAL:
          return `Chamada foi transferida para o ramal: <b>${info.infoIvrNode}</b> após <b>${formatElapsedSeconds(info.ivrSecs)}</b> na URA.`

        case IVR_TRANSFERTOAGENT:
          return `Chamada foi transferida para o agente: <b>${info.infoIvrNode}</b> após <b>${formatElapsedSeconds(info.ivrSecs)}</b> na URA.`

        case IVR_TRANSFEREXTERNAL:
          return `Chamada foi transferida para o número: <b>${this.displayPhoneWithTooltip(info.infoIvrNode)}</b> após <b>${formatElapsedSeconds(info.ivrSecs)}</b> na URA.`

        case IVR_TRANSFERTOURA:
          return `Chamada foi transferida para ura: <b>${info.infoIvrNode}</b> após <b>${formatElapsedSeconds(info.ivrSecs)}</b> na URA.`

        case IVR_TRANSFERQUEUE:
          return `Chamada foi transferida para fila: <b>${info.infoIvrNode}</b> após <b>${formatElapsedSeconds(info.ivrSecs)}</b> na URA.`

        case IVR_HANGUP:
          return `Chamada finalizada na URA: <b>${uraName}</b> após ${formatElapsedSeconds(info.ivrSecs)}.`

        default:
          return event
      }
    },

    handleTimelineTitle (action) {
      const { event, info } = action
      const ringSecs = info?.ringSecs ?? 0
      const totalSecs = ringSecs + (info?.talkSecs ?? 0)

      switch (event) {
        case QUEUEMEMBER_CALLCONNECT: return formatElapsedSeconds(ringSecs)
        case QUEUEMEMBER_CALLEND: return formatElapsedSeconds(totalSecs)
      }

      return '-'
    },

    handleTimelineTitleClass (action) {
      const { event } = action
      return [QUEUEMEMBER_CALLSTART, QUEUECALLER_JOIN].includes(event) ? 'hidden-entry' : ''
    },

    formatShowInfo (info) {
      const data = info.hidden ? '****' : info.infoIvrNode
      return data
    },

    formatMenuSelect (option) {
      if (option === 'invalid') return 'Cliente selecionou uma opção inválida'
      if (option === 'timeout') return 'Cliente não selecionou nenhuma opção'

      return `Cliente selecionou a opção ${option} na URA`
    },

    callEndStatus ({ info, agentName }) {
      if (this.status === 'COMPLETED' && info.reason === 'transfer') return `<br>Foi <b>Transferida</b> pelo agente <i>${agentName}</i>`
      if (this.status === 'COMPLETED') return '<br>Foi <b>Completada</b>'
      if (this.status === 'ABANDONED') return '<br>Foi <b>Abandonada</b>'
      if (this.status === 'DISCARDED') return '<br>Foi <b>Descartada</b>'
      return ''
    },

    callEndReason ({ info, agentName }) {
      if (this.status === 'ABANDONED') return ''
      if (this.status === 'DISCARDED') return ''
      if (info.reason === '') return ''
      if (info.reason === 'CALLER') return ' pelo <i>CONTATO</i>'
      if (info.reason === 'AGENT') return ` pelo agente <i>${agentName}</i>`
      return ''
    },

    callEndPosition () {
      return ['IN', 'AUTO'].includes(this.direction) && this.position ? `<br>Posição <b>${this.position}</b>` : ''
    },

    isAnonymizationEnabled (queue) {
      if (!queue) return false
      const queueProps = this.queueProperties(queue)
      return queueProps?.anonymizePhone === 'yes'
    }
  },

  computed: {
    ...mapGetters({
      queueProperties: 'agentModule/queueProperties'
    }),

    hasAnyAnonymization () {
      if (!this.history || !Array.isArray(this.history)) return false

      return this.history.some(action => {
        const queue = action?.info?.queue
        if (!queue) return false
        return this.isAnonymizationEnabled(queue)
      })
    }
  }
}
</script>

<style lang="sass" scoped>
  .align
    display: inline-grid

  .q-timeline
    margin: 0

  .q-timeline--dense--right .q-timeline__entry
    padding-left: 20px

  .hidden-entry > :first-child
    visibility: hidden

  .content
    font-weight: 400
    font-style: normal
    font-size: 13px
    line-height: 16px

  .description
    white-space: pre-wrap

  .header-agent
    font-style: normal
    font-weight: 600
    font-size: 13px
    line-height: 16px

  .label-legend
    font-size: 13px

  .icon
    height: 8px
    width: 8px
    border-radius: 8px

  .title
    font-size: 13px
    font-weight: 600
    font-style: normal
    line-height: 16px
    color: #263238

  .no-select
    user-select: none
    -webkit-user-select: none
    -moz-user-select: none
    -ms-user-select: none
</style>
